/* eslint-disable react/no-array-index-key,react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalBodyLayout from '../shared/ModalBodyLayout';
import { cardProviders, manageCardScreens } from './constants';
import { useUserCardProvider } from '../../utilities/sharedHooks/user';
import { GenericLoading } from '../../components/Placeholders';

const ViewPin = ({ pin, ...props }) => {
  const { t: translate } = useTranslation();
  const [hidePassword, setHidePassword] = useState(true);
  const [pinUrlLoading, setPinUrlLoading] = useState(true);

  const { cardProvider } = useUserCardProvider();

  const handlePress = () => {
    if (hidePassword) {
      setHidePassword(false);
    }
  };

  const handleHold = () => {
    if (!hidePassword) {
      setHidePassword(true);
    }
  };

  const renderFooter = () => (
    <button
      type="button"
      className="btn btn-secondary border text-dark py-3"
      onMouseDown={handlePress}
      onMouseUp={handleHold}
      onPointerDown={handlePress}
      onPointerUp={handleHold}>
      {translate('hold_to_reveal_btn_label')}
    </button>
  );

  const getInputs = () => {
    const inputs = [];
    pin.split('').map((char, index) => {
      inputs.push(
        <input
          key={`key-${char}-${index}`}
          id="pin"
          type={`${hidePassword ? 'password' : 'text'}`}
          className="border-0 text-bold text-f4 text-center bg-transparent text-dark"
          style={{ width: '2.5rem', height: '3rem', outline: 'none' }}
          name="password"
          value={char}
          readOnly
          disabled
        />
      );
      return true;
    });
    return inputs;
  };

  return (
    <ModalBodyLayout
      withBack
      isScrollable={false}
      title={translate('view_pin_title')}
      renderFooter={pin && cardProvider !== cardProviders.GALILEO ? renderFooter : () => {}}
      onPrevClick={() => props.openScreen(manageCardScreens.MAIN)}>
      <div className="mt-4">
        <p className={`text-dark p-0 text-f5 ${pin ? '' : 'text-bold'}`}>
          {pin ? translate('view_pin_subtitle') : translate('view_pin_not_available_note_1')}
        </p>
      </div>
      {cardProvider === cardProviders.GALILEO && (
        <>
          {(!pin || pinUrlLoading) && (
            <GenericLoading customSize="4rem" customSpacing="my-3" isFullScreen={false} />
          )}
          <div className="galileo-pin-iframe">
            <iframe
              hidden={pinUrlLoading}
              onLoad={() => {
                const timer = setTimeout(() => {
                  setPinUrlLoading(false);
                }, 2000);
                return () => clearTimeout(timer);
              }}
              className="h-100 w-100"
              title="PIN Url"
              src={pin}
            />
          </div>
        </>
      )}

      {cardProvider !== cardProviders.GALILEO && (
        <div
          className="form-group mt-4 d-flex flex-row justify-content-center py-2"
          style={{ gap: '1rem' }}>
          {pin ? (
            getInputs()
          ) : (
            <div className="mt-4">
              <p className="text-dard text-f5">{translate('view_pin_not_available_note_2')}</p>
              <p className="text-dard text-f5 mt-2">{translate('view_pin_not_available_note_3')}</p>
            </div>
          )}
        </div>
      )}
    </ModalBodyLayout>
  );
};

export default ViewPin;

ViewPin.propTypes = {
  openScreen: PropTypes.func.isRequired,
  pin: PropTypes.string.isRequired,
};
